export default __webpack_public_path__ + "static/media/research_purple.9d3d5e34.svg";